import '../../style.css'
import mainLogo from '../../assets/brand/exlibris90.png';
import { Select,  } from 'antd';

import LoadingOverlay from '../loadingOverlay/loadingOverlay';

function Home(props) {
    const handleDBChange = (selected) => {
    
        props.props.setSelectedDBCode(selected);
    }

    return (
        <main>
            <div className="container-sm custom-container">
                <div className="d-flex align-items-center p-3 my-3 text-black bg-white rounded shadow">
                    <div className='d-flex '>
                        <div className="col-sm-4 mx-2">
                            <img src={mainLogo} alt="Exlibris Logo" width="105" height="110" />
                        </div>
                        <div className="col-sm-12 my-3">
                            <div className="row">
                                <div className="col-md-12">
                                    <h4>Welcome to Exlibris</h4>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <h6>A Web-Based Database Query Tool</h6>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <h6>Version 2.0</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {props.props.databaseOptionsList.length > 1 &&
                    <div className="my-3 p-3 bg-body rounded shadow">
                        <h5 className="mb-3 text-center">Select Database to Query</h5>
                        <LoadingOverlay loading={props.props.loadingFilterObjects}/>
                        <Select
                            showSearch
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                option.label.toLowerCase().includes(input.toLowerCase())
                            }
                            style={{ width: '100%' }}
                            placeholder="Select Database"
                            name="Databases"
                            options={props.props.databaseOptionsList.map(db => ({
                                label: db.value,  
                                value: db.key     
                            }))}
                            value={props.props.selectedDBCode === '' ? undefined : props.props.selectedDBCode}
                            onChange={handleDBChange}
                            loading={props.props.loadingFilterObjects} // spinner is shown, but it's not disabled
                        />
                    </div>
                }
                <div className="my-3 p-3 bg-body rounded shadow">
                    <h5 className="text-center">Make a Query:</h5>
                    <div className="my-3 p-3 bg-body rounded shadow-sm">
                        <div className="row">
                            <div className="col-lg-4 mb-4 d-flex align-items-stretch">
                                <div className="card card-costum"
                                    onClick={() => {
                                        if (!props.props.loadingFilterObjects) { props.props.setActiveComponent('rawData') };
                                        props.props.checkDbSelected();
                                    }}>
                                    <div className="card-body" >
                                        <h5 className="card-title" style={{ fontSize: "18px", fontFamily: "Arial" }}>
                                            Raw Data
                                        </h5>
                                        <p className="card-text" style={{ fontSize: "14px", fontFamily: "Arial" }}>
                                            Query the database for raw data, filtering by years, locations, experiments, and traits
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 mb-4 d-flex align-items-stretch">
                                <div className="card card-costum"
                                    onClick={() => {
                                        if (!props.props.loadingFilterObjects) { props.props.setActiveComponent('rawDataSelectedLines') };
                                        props.props.checkDbSelected();
                                    }}>
                                    <div className="card-body">
                                        <h5 className="card-title" style={{ fontSize: "18px", fontFamily: "Arial" }}>
                                            Raw Data - Selected Lines
                                        </h5>
                                        <p className="card-text" style={{ fontSize: "14px", fontFamily: "Arial" }}>
                                            Query the database for raw data, filtering by years, locations, lines, experiments, and traits
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 mb-4 d-flex align-items-stretch">
                                <div className="card card-costum"
                                    onClick={() => {
                                        if (!props.props.loadingFilterObjects) { props.props.setActiveComponent('meansData') };
                                        props.props.checkDbSelected();
                                    }}>
                                    <div className="card-body">
                                        <h5 className="card-title" style={{ fontSize: "18px", fontFamily: "Arial" }}>
                                            Means Data
                                        </h5>
                                        <p className="card-text" style={{ fontSize: "14px", fontFamily: "Arial" }}>
                                            Query the database for means data, filtering by years, locations, experiments, and traits
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-lg-4 mb-4 d-flex align-items-stretch">
                                <div className="card card-costum"
                                    onClick={() => {
                                        if (!props.props.loadingFilterObjects) { props.props.setActiveComponent('meansDataSelectedLines') };
                                        props.props.checkDbSelected();
                                    }}>
                                    <div className="card-body">
                                        <h5 className="card-title" style={{ fontSize: "18px", fontFamily: "Arial" }}>
                                            Means Data - Selected Lines
                                        </h5>
                                        <p className="card-text" style={{ fontSize: "14px", fontFamily: "Arial" }}>
                                            Query the database for means data, filtering by years, locations, lines, experiments, and traits
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 mb-4 d-flex align-items-stretch">
                                <div className="card card-costum"
                                    onClick={() => {
                                        if (!props.props.loadingFilterObjects) { props.props.setActiveComponent('experiments') };
                                        props.props.checkDbSelected();
                                    }}>
                                    <div className="card-body">
                                        <h5 className="card-title" style={{ fontSize: "18px", fontFamily: "Arial" }}>
                                            Experiments
                                        </h5>
                                        <p className="card-text" style={{ fontSize: "14px", fontFamily: "Arial" }}>
                                            Query the database for experiments, filtering by years and lines
                                            <br />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 mb-4 d-flex align-items-stretch">
                                <div className="card card-costum"
                                    onClick={() => {
                                        if (!props.props.loadingFilterObjects) { props.props.setActiveComponent('blups') };
                                        props.props.checkDbSelected();
                                    }}>
                                    <div className="card-body">
                                        <h5 className="card-title" style={{ fontSize: "18px", fontFamily: "Arial" }}>
                                            BLUPs Analysis
                                        </h5>
                                        <p className="card-text" style={{ fontSize: "14px", fontFamily: "Arial" }}>
                                            Query the database for means data, view visualizations, and run BLUPs analysis on the data
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}


export default Home
